const reducer = (_, action) => {
    switch (action.type) {
        case 'SET':
            return action?.data;
        default:
            // istanbul ignore next
            throw new Error('Action type must be defined');
    }
};

export default reducer;
